<template>

    <div class="absolute w-screen h-auto top-0 left-0 z-20">


        <div class="w-full flex justify-between items-center relative px-6 sm:px-8 py-[10px] bg-dark-blue"
            style="height: var(--sidebar-height);"
            v-show="! is_responsive_menu">

            <font-awesome-icon class="text-white"
                style="
                    width: var(--sidebar-icon-length);
                    height: var(--sidebar-icon-length);
                "
                :icon="['far', 'bars']"
                @click="is_responsive_menu = ! is_responsive_menu"
            />

            <Logo class="h-full"
                :href="route('your_exercises')"
            />

            <div class=""
                style="
                    width: var(--sidebar-icon-length);
                    height: var(--sidebar-icon-length);
                ">
            </div>

        </div>


        <div class="w-screen h-screen bg-dark-blue flex flex-col"
            v-show="is_responsive_menu">


            <div class="w-full flex justify-between items-center relative px-6 sm:px-8 py-[10px]"
                style="height: var(--sidebar-height);">

                <font-awesome-icon class="text-white"
                    style="
                        width: var(--sidebar-icon-length);
                        height: var(--sidebar-icon-length);
                    "
                    :icon="['far', 'bars']"
                    @click="is_responsive_menu = ! is_responsive_menu"
                />

                <Logo class="h-full"
                    href="https://www.pausefitness.dk/"
                />

                <div class=""
                     style="
                        width: var(--sidebar-icon-length);
                        height: var(--sidebar-icon-length);
                    ">
                </div>

            </div>


            <nav class="w-full flex flex-col relative">

                <div class="absolute top-0 w-full z-10"
                     style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);height: 42px;"></div>


                <div class="grid grid-cols-2 px-4 py-4 z-20 relative">

                    <NavLink class="mb-2 col-span-2 border border-opacity-20 border-white"
                        :href="route('your_exercises')">

                        {{ __('Your exercises') }} <font-awesome-icon :icon="['fas', 'heart']"
                                                                      class="absolute right-4 text-red" />

                    </NavLink>

                    <NavLink class="mb-2 col-span-1"
                        v-for="category of $page.props.menu.exercise_categories"
                        :key="category.id"
                        :href="route('exercise_category', category.slug )"
                    >{{ __( category.name ) }}</NavLink>

                </div>


                <div class="rotate-180 absolute bottom-0 w-full z-10"
                     style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);height: 40px;"></div>

            </nav>


            <NavLink :href="route('notifications')"
                     class="mb-1 mx-4 mt-4"
            ><font-awesome-icon :icon="['far', 'bell']" class="mr-2" /> {{ __('Notifications') }}</NavLink>


            <NavLink :href="route('profile.show')"
                     class="mb-1 mx-4"
            ><font-awesome-icon :icon="['far', 'user']" class="mr-2" /> {{ __('User') }}</NavLink>


            <NavLink class="mb-1 mx-4"
                     :href="route('company.show', $page.props.menu.user_team_id )"
                     v-if="$page.props.menu.can_edit_company">

                <font-awesome-icon :icon="['far', 'building']" class="mr-2" />

                {{ __('Company') }}

            </NavLink>


            <form @submit.prevent="$emit('logout')" class="w-full px-4">
                <NavLink as="button"
                         class="mb-1 w-full"
                ><font-awesome-icon :icon="['far', 'power-off']" class="mr-2 text-red" /> {{ __('Log out') }}</NavLink>
            </form>


            <Version class="mt-auto"></Version>

        </div>


    </div>

</template>

<script>
import Logo from "../../Components/Logo";
import NavLink from "../../Components/NavLink";
import Version from "../../Components/Version";

export default {

    name: "HeaderResponsive",

    components: {
        Version,
        NavLink,
        Logo
    },

    data() {
        return {
            is_responsive_menu: false,
        }
    }

}
</script>

<style scoped>

</style>
